// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_container__c9TCE{
    display: flex;
    min-height: calc(100vh - 230px);
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.Dashboard_fundraisers__fKE2C{
    width: calc(100% - 523px);
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1320px){
    .Dashboard_container__c9TCE{
        flex-direction: column-reverse;
    }
    .Dashboard_fundraisers__fKE2C{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .Dashboard_fundraisers__fKE2C{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Dashboard_topSection__Fg7HW{
    display: flex;
    align-items: baseline;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}
@media(max-width: 820px){
    .Dashboard_topSection__Fg7HW{
        flex-wrap: wrap;
    }
}
.Dashboard_fundraisersHeader__ukqtN{
    text-align: left;
}
.Dashboard_bottomSection__VMtS3{
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}
@media(max-width: 1400px){
    .Dashboard_bottomSection__VMtS3{
        justify-content: center;
    }
}
.Dashboard_fundraiser__VlTzI{
    margin-bottom: 35px;
}
.Dashboard_fundraiser__VlTzI:not(:last-of-type){
    margin-right: 30px;
}
@media(max-width: 1400px){
    .Dashboard_fundraiser__VlTzI{
        width: calc(50% - 66px) !important;
    }
    .Dashboard_fundraiser__VlTzI:nth-of-type(even){
        margin-right: 0;
    }
}
@media(max-width: 1320px){
    .Dashboard_fundraiser__VlTzI{
        width: calc(33% - 68px) !important;
    }
    .Dashboard_fundraiser__VlTzI:nth-of-type(even){
        margin-right: 30px;
    }
    .Dashboard_fundraiser__VlTzI:nth-of-type(3n), .Dashboard_fundraiser__VlTzI:last-of-type{
        margin-right: 0;
    }
}
@media(max-width: 1200px){
    .Dashboard_fundraiser__VlTzI{
        width: calc(50% - 66px) !important;
    }
    .Dashboard_fundraiser__VlTzI:nth-of-type(even){
        margin-right: 0;
    }
    .Dashboard_fundraiser__VlTzI:nth-of-type(3n){
        margin-right: auto;
    }
}
@media(max-width: 820px){
    .Dashboard_fundraiser__VlTzI{
        width: calc(100% - 48px) !important;
        margin-bottom: 25px;
        margin-right: 0 !important;
    }
}
.Dashboard_rightSide__x80-M{
    display: flex;
    position: relative;
    top: -8px;
    margin-left: auto;
}
@media(max-width: 600px){
    .Dashboard_rightSide__x80-M{
        margin-top: 10px;
    }
}
.Dashboard_searchInput__Cdpma{
    margin-right: 20px;
}
@media(max-width: 820px){
    .Dashboard_rightSide__x80-M{
        width: 100%;
    }
    .Dashboard_searchInput__Cdpma{
        width: calc(100% - 150px);
    }
    .Dashboard_searchInput__Cdpma > div{
        width: 100%;
    }
    .Dashboard_searchInput__Cdpma input{
        width: calc(100% - 80px);
    }
}
@media(max-width: 460px){
    .Dashboard_searchInput__Cdpma input{
        width: calc(100% - 75px);
    }
}
.Dashboard_searchOrder__8yR0A{
    margin-left: auto;
}
.Dashboard_noFundraisersFound__meiyB, .Dashboard_noFundraisers__-FEDs{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 50px;
}
.Dashboard_noFundraisersFound__meiyB{
    margin-bottom: 40px;
}
.Dashboard_magnifyingGlassWithQuestionMark__Zo-jI, .Dashboard_coinJar__78zWJ{
    height: 60px;
    width: 60px;
}
.Dashboard_noFundraisersDescription__KCPRP{
    margin-top: 35px;
    color: #1F363D;
    text-align: center;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.Dashboard_noFundraisersFooter__IEOn5{
    margin-top: 15px;
    font-size: 16px;
}
.Dashboard_noFundraisersFooterBold__M8D4z{
    display: inline-block;
    margin-left: 4px;
    color: #40798CCC;
    font-size: 16px;
    font-family: 'Gotham Bold', serif;
}
.Dashboard_noFundraisersButton__asPNH{
    width: 150px;
    margin-top: 50px;
    margin-bottom: 30px;
    padding: 4px 20px;
    color: #FFFFFF;
    background-color: #40798C;
    font-size: 14px;
}
.Dashboard_impact__BvgrC{
    width: 383px;
    margin-top: 28px;
    padding-left: 35px;
    padding-right: 35px;
}
.Dashboard_impactHeader__g6XqM{
    margin-bottom: 30px;
    font-size: 32px;
    font-family: 'Gotham Bold', serif;
}
@media(max-width: 600px){
    .Dashboard_impact__BvgrC{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
    .Dashboard_impactHeader__g6XqM{
        font-size: 24px;
    }
}
.Dashboard_totalDonationsAmount__Gd2Wz, .Dashboard_totalNumOfDonations__wjDaW{
    display: flex;
    margin-bottom: 45px;
    padding: 36px 25px;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.Dashboard_totalDonationsAmount__Gd2Wz{
    background-color: #40798C1A;
    border: 1px solid #40798C1A;
}
.Dashboard_totalNumOfDonations__wjDaW{
    background-color: #70A9A11A;
    border: 1px solid #70A9A11A
}
@media(max-width: 1320px){
    .Dashboard_impact__BvgrC{
        width: calc(100% - 70px);
        margin-top: 10px;
    }
    .Dashboard_impactStats__pifr\\+{
        display: flex;
    }
    .Dashboard_totalDonationsAmount__Gd2Wz, .Dashboard_totalNumOfDonations__wjDaW{
        width: 50%;
        padding: 24px;
        margin-bottom: 30px;
    }
    .Dashboard_totalDonationsAmount__Gd2Wz{
        margin-right: 30px;
    }
}
@media(max-width: 820px){
    .Dashboard_impactStats__pifr\\+{
        flex-direction: column;
    }
    .Dashboard_totalDonationsAmount__Gd2Wz, .Dashboard_totalNumOfDonations__wjDaW{
        width: calc(100% - 40px);
        margin-bottom: 15px;
        margin-right: 0;
    }
}
@media(max-width: 600px){
    .Dashboard_impact__BvgrC{
        width: calc(100% - 40px);
    }
    .Dashboard_totalDonationsAmount__Gd2Wz, .Dashboard_totalNumOfDonations__wjDaW{
        width: calc(100% - 32px);
        padding: 16px;
    }
}
.Dashboard_totalDonationsAmountDisplay__vtiBL, .Dashboard_totalNumOfDonationsDisplay__9XBfP{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 113px;
    width: 113px;
    border-radius: 500px;
}
@media(max-width: 1320px){
    .Dashboard_totalDonationsAmountDisplay__vtiBL, .Dashboard_totalNumOfDonationsDisplay__9XBfP{
        height: 72px;
        width: 72px;
    }
}
@media(max-width: 400px){
    .Dashboard_totalDonationsAmountDisplay__vtiBL, .Dashboard_totalNumOfDonationsDisplay__9XBfP{
        height: 54px;
        width: 54px;
    }
}
.Dashboard_totalDonationsAmountDisplay__vtiBL{
    background-color: #40798CCC;
}
.Dashboard_totalNumOfDonationsDisplay__9XBfP{
    background-color: #70A9A1CC;
}
.Dashboard_impactImage__EGErI{
    height: 36px;
    width: 36px;
}
.Dashboard_impactDetails__ROzRf{
    width: calc(100% - 138px);
    margin-left: 25px;
}
.Dashboard_impactLabel__Qit9I{
    display: block;
    color: #1F363D;
    font-size: 18px;
    font-family: 'Gotham Medium', serif;
}
.Dashboard_impactValue__nwMZX{
    display: block;
    color: #1F363D;
    font-size: 72px;
    font-family: 'Gotham Bold', serif;
}
@media(max-width: 1320px){
    .Dashboard_impactLabel__Qit9I{
        font-size: 16px;
    }
    .Dashboard_impactValue__nwMZX{
        font-size: 40px;
    }
}
@media(max-width: 400px){
    .Dashboard_impactLabel__Qit9I{
        font-size: 14px;
    }
    .Dashboard_impactValue__nwMZX{
        font-size: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,mCAAmC;QACnC,mBAAmB;QACnB,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;IACf;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,eAAe;IACnB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container{\n    display: flex;\n    min-height: calc(100vh - 230px);\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.fundraisers{\n    width: calc(100% - 523px);\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1320px){\n    .container{\n        flex-direction: column-reverse;\n    }\n    .fundraisers{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .fundraisers{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.topSection{\n    display: flex;\n    align-items: baseline;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n}\n@media(max-width: 820px){\n    .topSection{\n        flex-wrap: wrap;\n    }\n}\n.fundraisersHeader{\n    text-align: left;\n}\n.bottomSection{\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 20px;\n}\n@media(max-width: 1400px){\n    .bottomSection{\n        justify-content: center;\n    }\n}\n.fundraiser{\n    margin-bottom: 35px;\n}\n.fundraiser:not(:last-of-type){\n    margin-right: 30px;\n}\n@media(max-width: 1400px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n}\n@media(max-width: 1320px){\n    .fundraiser{\n        width: calc(33% - 68px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 30px;\n    }\n    .fundraiser:nth-of-type(3n), .fundraiser:last-of-type{\n        margin-right: 0;\n    }\n}\n@media(max-width: 1200px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n    .fundraiser:nth-of-type(3n){\n        margin-right: auto;\n    }\n}\n@media(max-width: 820px){\n    .fundraiser{\n        width: calc(100% - 48px) !important;\n        margin-bottom: 25px;\n        margin-right: 0 !important;\n    }\n}\n.rightSide{\n    display: flex;\n    position: relative;\n    top: -8px;\n    margin-left: auto;\n}\n@media(max-width: 600px){\n    .rightSide{\n        margin-top: 10px;\n    }\n}\n.searchInput{\n    margin-right: 20px;\n}\n@media(max-width: 820px){\n    .rightSide{\n        width: 100%;\n    }\n    .searchInput{\n        width: calc(100% - 150px);\n    }\n    .searchInput > div{\n        width: 100%;\n    }\n    .searchInput input{\n        width: calc(100% - 80px);\n    }\n}\n@media(max-width: 460px){\n    .searchInput input{\n        width: calc(100% - 75px);\n    }\n}\n.searchOrder{\n    margin-left: auto;\n}\n.noFundraisersFound, .noFundraisers{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 50px;\n}\n.noFundraisersFound{\n    margin-bottom: 40px;\n}\n.magnifyingGlassWithQuestionMark, .coinJar{\n    height: 60px;\n    width: 60px;\n}\n.noFundraisersDescription{\n    margin-top: 35px;\n    color: #1F363D;\n    text-align: center;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.noFundraisersFooter{\n    margin-top: 15px;\n    font-size: 16px;\n}\n.noFundraisersFooterBold{\n    display: inline-block;\n    margin-left: 4px;\n    color: #40798CCC;\n    font-size: 16px;\n    font-family: 'Gotham Bold', serif;\n}\n.noFundraisersButton{\n    width: 150px;\n    margin-top: 50px;\n    margin-bottom: 30px;\n    padding: 4px 20px;\n    color: #FFFFFF;\n    background-color: #40798C;\n    font-size: 14px;\n}\n.impact{\n    width: 383px;\n    margin-top: 28px;\n    padding-left: 35px;\n    padding-right: 35px;\n}\n.impactHeader{\n    margin-bottom: 30px;\n    font-size: 32px;\n    font-family: 'Gotham Bold', serif;\n}\n@media(max-width: 600px){\n    .impact{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n    .impactHeader{\n        font-size: 24px;\n    }\n}\n.totalDonationsAmount, .totalNumOfDonations{\n    display: flex;\n    margin-bottom: 45px;\n    padding: 36px 25px;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.totalDonationsAmount{\n    background-color: #40798C1A;\n    border: 1px solid #40798C1A;\n}\n.totalNumOfDonations{\n    background-color: #70A9A11A;\n    border: 1px solid #70A9A11A\n}\n@media(max-width: 1320px){\n    .impact{\n        width: calc(100% - 70px);\n        margin-top: 10px;\n    }\n    .impactStats{\n        display: flex;\n    }\n    .totalDonationsAmount, .totalNumOfDonations{\n        width: 50%;\n        padding: 24px;\n        margin-bottom: 30px;\n    }\n    .totalDonationsAmount{\n        margin-right: 30px;\n    }\n}\n@media(max-width: 820px){\n    .impactStats{\n        flex-direction: column;\n    }\n    .totalDonationsAmount, .totalNumOfDonations{\n        width: calc(100% - 40px);\n        margin-bottom: 15px;\n        margin-right: 0;\n    }\n}\n@media(max-width: 600px){\n    .impact{\n        width: calc(100% - 40px);\n    }\n    .totalDonationsAmount, .totalNumOfDonations{\n        width: calc(100% - 32px);\n        padding: 16px;\n    }\n}\n.totalDonationsAmountDisplay, .totalNumOfDonationsDisplay{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 113px;\n    width: 113px;\n    border-radius: 500px;\n}\n@media(max-width: 1320px){\n    .totalDonationsAmountDisplay, .totalNumOfDonationsDisplay{\n        height: 72px;\n        width: 72px;\n    }\n}\n@media(max-width: 400px){\n    .totalDonationsAmountDisplay, .totalNumOfDonationsDisplay{\n        height: 54px;\n        width: 54px;\n    }\n}\n.totalDonationsAmountDisplay{\n    background-color: #40798CCC;\n}\n.totalNumOfDonationsDisplay{\n    background-color: #70A9A1CC;\n}\n.impactImage{\n    height: 36px;\n    width: 36px;\n}\n.impactDetails{\n    width: calc(100% - 138px);\n    margin-left: 25px;\n}\n.impactLabel{\n    display: block;\n    color: #1F363D;\n    font-size: 18px;\n    font-family: 'Gotham Medium', serif;\n}\n.impactValue{\n    display: block;\n    color: #1F363D;\n    font-size: 72px;\n    font-family: 'Gotham Bold', serif;\n}\n@media(max-width: 1320px){\n    .impactLabel{\n        font-size: 16px;\n    }\n    .impactValue{\n        font-size: 40px;\n    }\n}\n@media(max-width: 400px){\n    .impactLabel{\n        font-size: 14px;\n    }\n    .impactValue{\n        font-size: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dashboard_container__c9TCE`,
	"fundraisers": `Dashboard_fundraisers__fKE2C`,
	"topSection": `Dashboard_topSection__Fg7HW`,
	"fundraisersHeader": `Dashboard_fundraisersHeader__ukqtN`,
	"bottomSection": `Dashboard_bottomSection__VMtS3`,
	"fundraiser": `Dashboard_fundraiser__VlTzI`,
	"rightSide": `Dashboard_rightSide__x80-M`,
	"searchInput": `Dashboard_searchInput__Cdpma`,
	"searchOrder": `Dashboard_searchOrder__8yR0A`,
	"noFundraisersFound": `Dashboard_noFundraisersFound__meiyB`,
	"noFundraisers": `Dashboard_noFundraisers__-FEDs`,
	"magnifyingGlassWithQuestionMark": `Dashboard_magnifyingGlassWithQuestionMark__Zo-jI`,
	"coinJar": `Dashboard_coinJar__78zWJ`,
	"noFundraisersDescription": `Dashboard_noFundraisersDescription__KCPRP`,
	"noFundraisersFooter": `Dashboard_noFundraisersFooter__IEOn5`,
	"noFundraisersFooterBold": `Dashboard_noFundraisersFooterBold__M8D4z`,
	"noFundraisersButton": `Dashboard_noFundraisersButton__asPNH`,
	"impact": `Dashboard_impact__BvgrC`,
	"impactHeader": `Dashboard_impactHeader__g6XqM`,
	"totalDonationsAmount": `Dashboard_totalDonationsAmount__Gd2Wz`,
	"totalNumOfDonations": `Dashboard_totalNumOfDonations__wjDaW`,
	"impactStats": `Dashboard_impactStats__pifr+`,
	"totalDonationsAmountDisplay": `Dashboard_totalDonationsAmountDisplay__vtiBL`,
	"totalNumOfDonationsDisplay": `Dashboard_totalNumOfDonationsDisplay__9XBfP`,
	"impactImage": `Dashboard_impactImage__EGErI`,
	"impactDetails": `Dashboard_impactDetails__ROzRf`,
	"impactLabel": `Dashboard_impactLabel__Qit9I`,
	"impactValue": `Dashboard_impactValue__nwMZX`
};
export default ___CSS_LOADER_EXPORT___;
